<script setup>
// Onboarding MIDI step (MDL-326). Reuses DeviceSettingsForm so the wizard
// shares one channel/device editor across both editors. It mutates `settings`
// in place (settings.channel = Midulate's own MIDI channel; settings.devices[i]
// = per-channel name + CC labels), and the wizard persists the whole config on
// exit. See spec 144080898 §2.3.
//
// This is the *manual* path: showLibrarySearch defaults to false so the step is
// fully usable without the OpenMIDI catalogue. MDL-327 turns the library search
// on (with a graceful manual fallback) to auto-populate CCs for known pedals.
//
// showLoopback is false here: internal MIDI loopback is for someone who already
// understands how Midulate modulates itself, and in DeviceSettingsForm it takes
// a whole fieldset and a paragraph of explanation — as much weight as the MIDI
// channel. On a first run that competes with the two things that matter, so it
// stays in Settings for when the owner goes looking (MDL-387).

import DeviceSettingsForm from '../DeviceSettingsForm.vue';

defineProps({
  // The device config's `settings` object; DeviceSettingsForm writes
  // channel/devices onto it.
  settings: {
    type: Object,
    required: true,
  },
  // Enable the MIDI-library (OpenMIDI) preset search in the edit modal.
  // Off during manual onboarding; MDL-327 flips it on per editor/transport.
  showLibrarySearch: {
    type: Boolean,
    default: false,
  },
  // Forwarded to DeviceSettingsForm → DeviceEditModal (absolute-URL client for
  // the on-device editor; default relative client for the web editor).
  apiClient: {
    type: Object,
    default: undefined,
  },
});
</script>

<template>
  <div class="space-y-4">
    <p class="text-xl text-center p-2">
      You can make Midulate easier to work with by labelling your MIDI channels.
    </p>

    <p class="text-base-content/80 text-center p-2">
      You can also look up devices in the MIDI library in order to label their parameters.
    </p>

    <DeviceSettingsForm
      :show-loopback="false"
      :settings="settings"
      :show-library-search="showLibrarySearch"
      :api-client="apiClient"
    />
  </div>
</template>
